import { z } from 'zod';
import { FinanceStructureSchema, DeskingEquipmentFormPartSchema } from 'modules/desking/shared';

const actionsSchema = z.object({
  sendVia: z.string(),
  notifyUsers: z.array(
    z.object({
      group: z.string(),
      title: z.string(),
      fullName: z.string(),
      email: z.string().email(),
    })
  ),
});

const submissionSchema = z.object({
  decision: z.string().optional(),
  noteToBuyer: z.string().optional(),
  maxApprovalAmount: z.number().optional(),
  selectedSubmissionId: z.string().optional(),
});

const financeProgramDescriptionSchema = z.object({
  apiValue: z.string().optional(),
  editorValue: z.any().optional(),
});

const displaySettingsSchema = z.object({
  productPrice: z.boolean(),
  productDetails: z.boolean(),
  showLenderLogo: z.boolean(),
  showLenderName: z.boolean(),
  showBestOptions: z.boolean(),
  showInterestRate: z.boolean(),
  excludeEquipmentSales: z.boolean(),
  shouldRedirectToOCA: z.boolean(),
  lenderProfileId: z.string().nullable(),
  showFinanceProgramDescription: z.boolean(),
});

export const lenderDeskingDataShema = z
  .object({
    actions: actionsSchema,
    submission: submissionSchema,
    lenderDescription: z.string(),
    displaySettings: displaySettingsSchema,
    financeProgramDescription: financeProgramDescriptionSchema,
  })
  .and(DeskingEquipmentFormPartSchema)
  .and(FinanceStructureSchema);
